/**
 * De ingangsdatum van de nieuwe verlofsoorten (Story 5.4, AC-5/AC-7/AC-10).
 *
 * DE ENE plek waar het scherm deze datum vandaan haalt. Wie hem nodig heeft —
 * het aanvraagformulier, "Mijn verlof", de goedkeuringslijst en straks de
 * maandteller uit epic 6 — roept déze hook aan en leest nergens zelf een
 * instelling uit.
 *
 * `data` is `null` zodra de rij ontbreekt, leeg is of onleesbaar is; zolang de
 * query laadt of mislukt blijft hij `undefined`. Beide betekenen hetzelfde
 * voor de schermen: **de nieuwe regels gelden niet**. Er is bewust geen
 * standaarddatum — een standaard in het verleden zou het hele
 * verlofsoorten-werk stilzwijgend aanzetten (KE-8, AC-2).
 *
 * De vergelijking zelf staat niet hier maar in `valtOnderNieuweVerlofregels`
 * (`packages/shared`) — één afleiding, drie lezers (KE-9).
 */

import { useQuery } from '@tanstack/react-query';
import { systemSettingsApi } from '../../../lib/settingsApi';

export const verlofsoortKeys = {
  ingangsdatum: ['settings', 'verlofsoortIngangsdatum'] as const,
};

export function useVerlofsoortIngangsdatum() {
  return useQuery({
    queryKey: verlofsoortKeys.ingangsdatum,
    queryFn: () => systemSettingsApi.getVerlofsoortIngangsdatum(),
    // De schakelaar verandert hooguit één keer; hem bij elke sheet opnieuw
    // ophalen levert alleen verkeer op.
    staleTime: 1000 * 60 * 5,
  });
}
